/**
 * @param {Object} aircraftData - Aircraft object (tailNumber/cAircraftTailNumber, isFleet)
 * @returns {boolean}
 */
export const isFloatingFleet = (aircraftData) => {
    return (
        aircraftData?.tailNumber?.indexOf("XX-XXX") > -1 ||
        aircraftData?.cAircraftTailNumber?.indexOf("XX-XXX") > -1 ||
        aircraftData?.isFleet
    );
};

/**
 *
 * @param {Object} details - Response from get-price-confirmation-details
 * @param {Object} aircraftData - Response from get-single-searchresult
 * @returns {Object} details with the aircraft spec fields filled in
 */
export const withAircraftSpecs = (details, aircraftData) => {
    if (!details) {
        return details;
    }

    return {
        ...details,
        category: details.category ?? aircraftData?.category,
        yom: details.yom ?? aircraftData?.yom,
        refurbishedYear: details.refurbishedYear ?? aircraftData?.refurbishedYear,
        cateringOption: details.cateringOption ?? aircraftData?.cateringOption ?? details.cateringOptionText,
        pets: details.pets ?? aircraftData?.pets ?? details.number_of_Pets,
    };
};
